import React from 'react';
import './why-choose-us.css';

const advantages = [
  {
    number: '01',
    title: 'Built around your business',
    description:
      'Every decision starts with your goals, customers and day-to-day reality—not a one-size-fits-all template.',
    icon: 'bx bx-target-lock',
  },
  {
    number: '02',
    title: 'One reliable partner',
    description:
      'Strategy, design, development and support stay connected through one clear and accountable collaboration.',
    icon: 'bx bx-link-alt',
  },
  {
    number: '03',
    title: 'Quality that lasts',
    description:
      'We build responsive, maintainable solutions with strong technical foundations that can grow over time.',
    icon: 'bx bx-shield-quarter',
  },
  {
    number: '04',
    title: 'Clear from start to finish',
    description:
      'You receive honest advice, visible progress and straightforward communication at every stage.',
    icon: 'bx bx-message-square-check',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose" id="why-choose-us">
      <div className="why-choose-inner">
        <div className="why-choose-story">
          <span className="why-choose-eyebrow">WHY CHOOSE US</span>
          <h2>Technology is only valuable when it creates real progress.</h2>
          <p>
            We combine business understanding, thoughtful design and dependable
            development to create solutions that are useful today and ready for
            tomorrow.
          </p>

          <div className="why-choose-statement">
            <span aria-hidden="true">“</span>
            <p>
              We do not simply deliver a product. We build clarity, trust and a
              digital foundation your business can rely on.
            </p>
          </div>

          <a href="#contact" className="why-choose-cta">
            Work with us
            <span aria-hidden="true">→</span>
          </a>
        </div>

        <div className="why-choose-grid">
          {advantages.map((advantage) => (
            <article className="why-choose-card" key={advantage.number}>
              <div className="why-choose-card-top">
                <span className="why-choose-number">{advantage.number}</span>
                <span className="why-choose-icon" aria-hidden="true">
                  <i className={advantage.icon} />
                </span>
              </div>
              <h3>{advantage.title}</h3>
              <p>{advantage.description}</p>
            </article>
          ))}
        </div>
      </div>

      <div className="why-choose-values" aria-label="Kodex Solutions values">
        <span>Business focused</span>
        <i aria-hidden="true" />
        <span>Human centred</span>
        <i aria-hidden="true" />
        <span>Technically reliable</span>
        <i aria-hidden="true" />
        <span>Ready to grow</span>
      </div>
    </section>
  );
};

export default WhyChooseUs;
